import { useStores } from 'index';

export enum ResponseState {
  init = 'init',
  success = 'success',
  error = 'error',
}

interface IApiError {
  errors: IApiErrorsArray[];
}

interface IApiErrorsArray {
  error_code: string;
  error_details: IApiErrorDetails;
}

interface IApiErrorDetails {
  _exception_type: string;
  _exception_message: string;
}

export interface IAxiosApiReducer<T> {
  isLoading: boolean;
  responseState: ResponseState;
  data: T;
  errorMessage: string;
  httpStatus: number;
  customData: any;
}

export const AxiosApiReducer = <TOutput>(state: IAxiosApiReducer<TOutput>, action: any): IAxiosApiReducer<TOutput> => {
  if (action.type === 'FETCH_INIT')
    return {
      ...state,
      isLoading: true,
      responseState: ResponseState.init,
      data: action?.payload,
      httpStatus: action?.httpStatus,
      errorMessage: '',
      customData: action.customData,
    };

  if (action.type === 'FETCH_SUCCESS') {
    const responseBag = {
      ...state,
      isLoading: false,
      responseState: ResponseState.success,
      data: action?.payload?.data || action?.payload,
      httpStatus: action?.httpStatus,
      errorMessage: '',
      customData: action?.customData,
    };

    if (action.purpose && action.notificationStore && action.displayNotifications) {
      action.notificationStore.displayNotification({
        response: responseBag,
        purpose: action.purpose,
      });
    }

    return responseBag;
  }

  if (action.type === 'FETCH_ERROR') {
    const errors = (action?.payload as IApiError)?.errors;

    // todo!: refactor below responseBag
    // the reason for was that we sometimes receive different error response schema from backend
    const responseBag = {
      ...state,
      isLoading: false,
      responseState: ResponseState.error,
      data: {} as TOutput,
      httpStatus: action?.httpStatus,
      errorMessage:
        typeof action?.payload?.errorMessage === 'string'
          ? action?.payload.errorMessage
          : errors && errors.length > 0 && errors[0].error_details
          ? errors[0].error_details._exception_message
          : 'Error',
      customData: action?.customData,
    };

    if (action.notificationStore && action.displayNotifications) {
      action.notificationStore.displayNotification({
        response: responseBag,
        purpose: action.purpose,
      });
    }

    return responseBag;
  }

  throw new Error();
};
